import { render, staticRenderFns } from "./ProductDetailSale.vue?vue&type=template&id=025eb34a&scoped=true&"
import script from "./ProductDetailSale.vue?vue&type=script&lang=js&"
export * from "./ProductDetailSale.vue?vue&type=script&lang=js&"
import style0 from "./ProductDetailSale.vue?vue&type=style&index=0&id=025eb34a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/.15.9.3@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "025eb34a",
  null
  
)

export default component.exports